// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608051704/js/" + chunkId + "." + {"44":"33e6bcdc","225":"e56d934b","481":"0c71301d","486":"c0327af4","770":"a3a3cd64"}[chunkId] + ".0.7017364157403946.chunk.js";
};